module.exports = __webpack_public_path__ + "img/mallamosquitera.03afe18b.jpg";